import TypeLoadList from './TypeLoadList'

export default TypeLoadList
